import React from 'react';
import PropTypes from 'prop-types';
import calendarIcon from '../customIcons/calendarIcon.svg';
import inIcon from '../customIcons/inIcon.svg';
import outIcon from '../customIcons/outIcon.svg';
import liveIcon from '../customIcons/liveIcon.svg';
import fixedIcon from '../customIcons/fixedIcon.svg';
import outDisabledIcon from '../customIcons/outDisabledIcon.svg';



export const IconCustomType = {
  IN:inIcon,
  OUT:outIcon,
  OUTDISABLED:outDisabledIcon,
  FIXED:fixedIcon,
  LIVE:liveIcon
  
};

export const IconSize = {
  LARGE: 'lg',
  SMALL: 'sm',
  DOUBLE: '2x',
};

const IconCustom = (props) => {
  const {
    icon, iconSize, iconColor, className,
  } = props;
  const getIcon=(icon)=>{

  }
  return (
    <img src={icon}/>
  );
};

IconCustom.propTypes = {
  icon: PropTypes.oneOf(Object.values(IconCustomType)).isRequired,
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  iconColor: PropTypes.string,
  className: PropTypes.string,
};

IconCustom.defaultProps = {
  iconSize: IconSize.SMALL,
  iconColor: '',
  className: '',
};

export default IconCustom;
